const KEY = 'mingo_cookie_consent_v1';

/**
 * @returns {null | { essential: boolean, analytics: boolean, marketing: boolean, at: string }}
 */
export function loadCookieConsent() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || typeof p !== 'object') return null;
    return {
      essential: true,
      analytics: !!p.analytics,
      marketing: !!p.marketing,
      at: typeof p.at === 'string' ? p.at : new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

/**
 * @param {{ essential?: boolean, analytics: boolean, marketing: boolean }} v
 */
export function saveCookieConsent(v) {
  const payload = {
    essential: true,
    analytics: !!v.analytics,
    marketing: !!v.marketing,
    at: new Date().toISOString(),
  };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event('mingo-cookie-consent'));
}
